import { Modal } from '@tryhackme/thm-ui-components';
import { faShare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactComponent as ImageRoomCompleted } from 'src/images/svgs/rooms/completion-modal/room-completed.svg';
import { SocialSharing } from '../../../completion-modal/components/social-sharing';
import { ShareRoomsCompletionModalProps } from './completion-modal-share-roomcompletion-share-room-modal.types';
import { StyledShareButton, StyledWrapperContent } from './completion-modal-share-roomcompletion-share-room-modal.styles';
export const CompletionShareRoomModal = ({
  roomCode,
  roomType,
  onOpenChange,
  isShareModalOpen,
  setIsShareModalOpen,
  isCompletionShareRoomModal,
  ...otherModalProps
}: ShareRoomsCompletionModalProps) => <Modal {...otherModalProps} onOpenChange={onOpenChange} open={isShareModalOpen} triggerElement={<StyledShareButton>
        <FontAwesomeIcon icon={faShare} />
        Share your achievement
      </StyledShareButton>} data-sentry-element="Modal" data-sentry-component="CompletionShareRoomModal" data-sentry-source-file="completion-share-room-modal.tsx">
    <StyledWrapperContent data-sentry-element="StyledWrapperContent" data-sentry-source-file="completion-share-room-modal.tsx">
      <ImageRoomCompleted data-testid="room-completed-img" height={160} data-sentry-element="ImageRoomCompleted" data-sentry-source-file="completion-share-room-modal.tsx" />
      <h2>Share your achievement!</h2>
      <p>Stand out to employers in cyber security!</p>
      <SocialSharing roomType={roomType ?? 'challenge'} roomCode={roomCode ?? ''} isCompletionShareRoomModal data-sentry-element="SocialSharing" data-sentry-source-file="completion-share-room-modal.tsx" />
    </StyledWrapperContent>
  </Modal>;